import { useGetCity as r } from "./useGetCity.js";
import { useGetGroups as t } from "./useGetGroups.js";
import { useGetOrganization as o } from "./useGetOrganization.js";
import { useGetQuery as i } from "./useGetQuery.js";
import { useBusinessModalContext as n } from "../../../BusinessModalContext.js";
const c = () => {
  const {
    filters: e
  } = n(), {
    business__in: u,
    business__notin: m,
    ...s
  } = e;
  return {
    ...s,
    ...i(),
    ...r(),
    ...o(),
    ...t(),
    order_by: "-created"
  };
};
export {
  c as useBusinessesQueryParams
};
